import { useLayoutEffect, useEffect } from 'react';
import { canUseDom } from './dom-utils';

export default canUseDom() ? useLayoutEffect : useEffect;
